import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import BanquesConnecteResults from './BanquesConnecteResults';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import ScopeField from '../../components/ScopeField';
import { todayISO } from '../../utils/date';
import './BanquesConnectePage.css';

const BanquesConnectePage = () => {
  const [showResults, setShowResults] = useState(false);

  const [filter, setFilter] = useState('Tout');
  const [scopeId, setScopeId] = useState('0');
  const [scopeName, setScopeName] = useState('');
  const [lottery, setLottery] = useState('0');
  const [lotteryName, setLotteryName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [refreshEvery, setRefreshEvery] = useState('180');
  const [statut, setStatut] = useState('Tout');
  const [inColumn, setInColumn] = useState(false);
  const [offlineMinutes, setOfflineMinutes] = useState('5');
  const [zoneId, setZoneId] = useState('0');
  const [divisionId, setDivisionId] = useState('0');

  const handleFilterChange = (opt) => {
    setFilter(opt);
    setScopeId('0');
    setScopeName('');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  if (showResults) {
    return (
      <BanquesConnecteResults
        filter={filter}
        scopeId={scopeId}
        lottery={lottery}
        date={date}
        refreshEvery={refreshEvery}
        statut={statut}
        inColumn={inColumn}
        offlineMinutes={offlineMinutes}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <Layout>
      <p className="bc-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/central" className="bc-link">Central</Link>
        {' >> '}
        <Link to="/banques-connecte" className="bc-link">Banques Connecte</Link>
      </p>

      <div className="bc-card">
        <div className="bc-card-header">
          <span className="bc-card-title">Monitoring de la Banque</span>
        </div>
        <div className="bc-card-body">
          <div className="bc-radio-row">
            {['Tout', 'Groupe', 'Superviseur'].map((opt) => (
              <label key={opt} className="bc-radio-label">
                <input
                  type="radio"
                  name="filter"
                  value={opt}
                  checked={filter === opt}
                  onChange={() => handleFilterChange(opt)}
                />
                {opt}
              </label>
            ))}
          </div>

          {filter !== 'Tout' && (
            <div className="bc-row bc-scope-row">
              <label className="bc-label">{filter}</label>
              <ScopeField
                filter={filter}
                id={scopeId}
                name={scopeName}
                onResolve={(id, nm) => { setScopeId(id); setScopeName(nm); }}
                inputClass="bc-input bc-input-sm"
                iconClass="bc-icon-btn"
                nameClass="bc-scope-name"
              />
            </div>
          )}

          <form onSubmit={handleSearch} className="bc-form">
            <div className="bc-row">
              <label className="bc-label">Loterie</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={(code) => { setLottery(code); setLotteryName(''); }}
                onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                inputClass="bc-input bc-input-sm"
                iconClass="bc-icon bc-icon-btn"
                nameClass="bc-scope-name"
              />
            </div>

            <div className="bc-row">
              <label className="bc-label">Date</label>
              <DateField className="bc-input bc-input-date" value={date} onChange={setDate} />
              <label className="bc-label bc-label-gap">Actualisez Chaque</label>
              <input className="bc-input bc-input-sm" type="text" value={refreshEvery} onChange={e => setRefreshEvery(e.target.value)} />
              <span className="bc-unit">Scds</span>
            </div>

            <div className="bc-row">
              <label className="bc-label">Statut de la Banque</label>
              <select className="bc-select" value={statut} onChange={e => setStatut(e.target.value)}>
                <option value="Tout">Tout</option>
                <option value="En ligne">En ligne</option>
                <option value="Deconnecte">Deconnecte</option>
                <option value="N'a pas connecte">N'a pas connecte</option>
              </select>
              <label className="bc-label bc-label-gap bc-checkbox-label">
                Dans une colonne
                <input type="checkbox" checked={inColumn} onChange={e => setInColumn(e.target.checked)} />
              </label>
            </div>

            <div className="bc-row">
              <label className="bc-label bc-label-wide">Minutes a considerer une banque comme deconnecte</label>
              <input className="bc-input bc-input-sm" type="text" value={offlineMinutes} onChange={e => setOfflineMinutes(e.target.value)} />
              <span className="bc-unit">Mins</span>
            </div>

            <div className="bc-row">
              <label className="bc-label">Zone ID</label>
              <input className="bc-input bc-input-sm" type="text" value={zoneId} onChange={e => setZoneId(e.target.value)} />
              <span className="bc-icon">🔍</span>
            </div>

            <div className="bc-row">
              <label className="bc-label">Division ID</label>
              <input className="bc-input bc-input-sm" type="text" value={divisionId} onChange={e => setDivisionId(e.target.value)} />
              <span className="bc-icon">🔍</span>
            </div>

            <button type="submit" className="bc-search-btn">Chercher</button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default BanquesConnectePage;
